import React from 'react';
import { NavLink } from 'react-router-dom';
import GConf from '../../AssetsM/generalConf'
function LinkCard(props) {
    return ( <>
        <div className='card p-2 shadow-sm border-div bg-hover-card mb-2 text-center h-100 ' style={{color: GConf.themeColor}}>
                <NavLink exact='true' to={props.data.link} className="stretched-link"></NavLink>
                <h3 className={`bi bi-${props.data.icon} bi-lg mb-0 mt-1`} ></h3> 
                <h5 className='mt-1 mb-1'>{props.data.text}</h5>
        </div> 
    </> );
}

export default LinkCard;